import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import tooltip from '@/mixins/components/tooltip';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('storm-account-options', {
  template: require('./template.html'),
  name: 'storm-account-options',
  mixins: [guid],
  components: {
    dropsLoader,
    tooltip,
  },
  computed: {
    ...mapGetters(['currentUser', 'account']),
  },
  data() {
    return {
      loading: false,
      options: {
        creator: false,
        owner: false,
        paymentMethod: false,
        status: 'active',
        accountType: 'general',
        notes: '',
      },
      statuses: [
        'active',
        'balance_unpaid',
        'delinquent',
        'expired',
        'disabled',
      ],
      types: [
        'general',
        'exempt',
        'bundle',
        'church',
      ],
    };
  },
  created() {
    this.setInitialValues();
  },
  methods: {
    setInitialValues() {
      this.options.creator = this.currentUser.creator;
      this.options.owner = this.currentUser.owner;
      this.options.paymentMethod = this.currentUser.paymentMethod;
      this.options.status = this.currentUser.status;
      this.options.accountType = this.currentUser.accountType || 'general';
      this.options.notes = this.currentUser.notes || '';
    },
    async saveAccountChanges() {
      if (this._storm || this._dev) {
        this.loading = true;
        let type = 'success';
        let message = 'Account options saved successfully!';
        try {
          await this.$lightning([{
            name: 'updateAccount',
            payload: { options: this.options },
          }]);
          _.forOwn(this.options, (value, key) => {
            this.$store.dispatch('setGlobalValue', {
              item: this.currentUser,
              key,
              value,
            });
            this.$store.dispatch('setGlobalValue', {
              item: this.account,
              key,
              value,
            });
          });
        } catch (e) {
          message = e.message || e;
          type = 'error';
          this.$log.error(message);
        } finally {
          this.loading = false;
          this.$store.dispatch('addNotification', {
            id: this.guid(),
            type,
            message,
          });
        }
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/admin/account-options/index.js